import { SettingsIcon } from '@chakra-ui/icons'
import { Flex, IconButton } from '@chakra-ui/react'
import { AnyObject } from '@hb/shared'
import { ItemActionsProps } from '../../EditHeader'
import { useTemplatesView } from '../TemplatesViewContext'

export const ConsentFormItemActions = <T extends AnyObject>({ item }: ItemActionsProps<T>) => {
  const { editConsentFormSettings } = useTemplatesView()
  return (
    <Flex align="center">
      <IconButton
        icon={<SettingsIcon />}
        variant="ghost"
        size="xs"
        aria-label="Settings"
        onClick={() => editConsentFormSettings(item.id)}
      />
    </Flex>
  )
}
